interface ITightKnitEnvironment {
    TIGHT_KNIT_API_BASE_PATH?: string;
    TIGHT_KNIT_ENV?: string;
    TIGHT_KNIT_TRACKJS_APP_KEY?: string;
    TIGHT_KNIT_MIXPANEL_TOKEN?: string;
}

declare global {
    // tslint:disable-next-line:interface-name
    interface Window {
        tightKnitEnv?: ITightKnitEnvironment
    }
}

// Default assumes API is on the same host and port as e.g., index.html and the bundled script.
// You can configure the dev proxy to redirect to e.g., port 8080 for local development.
let tightKnitApiBasePath = 'https://api-dev.tightknit.com/api/v1/';
let tightKnitEnv = 'local';
let tightKnitTrackJsAppKey = '';
let tightKnitMixpanelToken = '';

if (window.tightKnitEnv && window.tightKnitEnv.TIGHT_KNIT_API_BASE_PATH) {
    // If defined, use E.g., Heroku environment variables that are baked into index.html on deploy instead.
    tightKnitApiBasePath = window.tightKnitEnv.TIGHT_KNIT_API_BASE_PATH;
}
if (window.tightKnitEnv && window.tightKnitEnv.TIGHT_KNIT_ENV) {
    // If defined, use E.g., Heroku environment variables that are baked into index.html on deploy instead.
    tightKnitEnv = window.tightKnitEnv.TIGHT_KNIT_ENV;
}
if (window.tightKnitEnv && window.tightKnitEnv.TIGHT_KNIT_TRACKJS_APP_KEY) {
    // If defined, use E.g., Heroku environment variables that are baked into index.html on deploy instead.
    tightKnitTrackJsAppKey = window.tightKnitEnv.TIGHT_KNIT_TRACKJS_APP_KEY;
}
if (window.tightKnitEnv && window.tightKnitEnv.TIGHT_KNIT_MIXPANEL_TOKEN) {
    // If defined, use E.g., Heroku environment variables that are baked into index.html on deploy instead.
    tightKnitMixpanelToken = window.tightKnitEnv.TIGHT_KNIT_MIXPANEL_TOKEN;
}

// Override for local testing against remote staging server but don't commit uncommented.
// tightKnitApiBasePath = 'https://nl-tightknit-server-2.herokuapp.com/api/v1/';
// tightKnitApiBasePath = 'https://tightknit-app-server.herokuapp.com/api/v1/';

export const TIGHT_KNIT_API_BASE_PATH = tightKnitApiBasePath;
export const TIGHT_KNIT_ENV = tightKnitEnv;
export const TIGHT_KNIT_TRACKJS_APP_KEY = tightKnitTrackJsAppKey;
export const TIGHT_KNIT_MIXPANEL_TOKEN = tightKnitMixpanelToken;



// WEBPACK FOOTER //
// ./src/Config/Environment.ts